import { HiddenAreaConverter } from './HiddenAreaConverter';
import { HiddenAreaWidgetServerModelHelper } from './HiddenAreaServerModel';
import { HtmlWidgetConverter } from './HtmlWidgetConverter';
import { HtmlWidgetServerModelHelper } from './HtmlWidgetServerModel';
import { MultipleResponseQuestionWidgetServerModelHelper } from './MultipleResponseQuestionServerModel';
import { MultipleResponseQuestionWidgetConverter } from './MultipleResponseQuestionWidgetConverter';
import { SingleResponseQuestionWidgetServerModelHelper } from './SingleResponseQuestionServerModel';
import { SingleResponseQuestionWidgetConverter } from './SingleResponseQuestionWidgetConverter';
import { convertInteractiveProcessFromServerModel, convertInteractiveProcessWidgetToServerModel, } from './InteractiveProcessServerModel';
import { convertImageCarouselFromServerModel, convertImageCarouselWidgetToServerModel, } from './ImageCarouselServerModel';
import { convertInteractiveTabsFromServerModel, convertInteractiveTabsWidgetToServerModel, } from './InteractiveTabsServerModel';
import { convertFlipCardWidgetFromServerModel, convertFlipCardWidgetToServerModel } from './FlipCardServerModel';
import { FillInQuestionWidgetConverter } from './FillInQuestionServerModel';
import { TextOnImageWidgetHelper } from '../content/contentBuilder/widgets/TextOnImageWidget';
import { convertTextOnImageFromServerModel, convertTextOnImageWidgetToServerModel } from './TextOnImageServerModel';
import { ListWidgetHelper } from '../content/contentBuilder/widgets/ListWidget';
import { convertListFromServerModel, convertListWidgetToServerModel } from './ListServerModel';
import { convertLabeledGraphicFromServerModel, convertLabeledGraphicToServerModel } from './LabeledGraphicServerModel';
import { LabeledGraphicHelper } from '../content/contentBuilder/widgets/LabeledGraphic';
import { convertDividerFromServerModel, convertDividerWidgetToServerModel } from './DividerServerModel';
import { SortationQuestionWidgetConverter } from './SortationQuestionWidgetConverter';
import { SortationQuestionWidgetServerModelHelper } from './SortationQuestionServerModel';
import { FillInQuestionHelper } from '../content/contentBuilder/widgets/FillInQuestionWidget';
import { InteractiveProcessHelper } from '../content/contentBuilder/widgets/InteractiveProcess';
import { ImageCarouselWidgetHelper } from '../content/contentBuilder/widgets/ImageCarouselWidget';
import { InteractiveTabsHelper } from '../content/contentBuilder/widgets/InteractiveTabs';
import { FlipCardWidgetHelper } from '../content/contentBuilder/widgets/FlipCard';
import { DividerWidgetHelper } from '../content/contentBuilder/widgets/DividerWidget';
import { WidgetHelper } from '../content/contentBuilder/widgets/Widget';
import { SingleResponseQuestionHelper } from '../content/contentBuilder/widgets/SingleResponseQuestionWidget';
import { MultipleResponseQuestionHelper } from '../content/contentBuilder/widgets/MultipleResponseQuestionWidget';
import { HtmlWidgetHelper } from '../content/contentBuilder/widgets/HtmlWidget';
import { HiddenAreaWidgetHelper } from '../content/contentBuilder/widgets/HiddenAreaWidget';
export const WidgetConverter = {
    convertToDomainModel: (widget) => {
        try {
            if (SingleResponseQuestionWidgetServerModelHelper.isQuestionWidgetServerModel(widget)) {
                return SingleResponseQuestionWidgetConverter.convertDomainModel(widget);
            }
            if (MultipleResponseQuestionWidgetServerModelHelper.isMultipleResponseQuestionWidgetServerModel(widget)) {
                return MultipleResponseQuestionWidgetConverter.convertDomainModel(widget);
            }
            if (FillInQuestionHelper.isFillInQuestionWidgetServerModel(widget)) {
                return FillInQuestionWidgetConverter.convertDomainModel(widget);
            }
            if (HtmlWidgetServerModelHelper.isHtmlWidgetServerModel(widget)) {
                return HtmlWidgetConverter.convertDomainModel(widget);
            }
            if (HiddenAreaWidgetServerModelHelper.isHiddenAreaWidgetServerModel(widget)) {
                return HiddenAreaConverter.convertToDomainModel(widget);
            }
            if (InteractiveProcessHelper.isInteractiveProcessWidgetServerData(widget)) {
                return convertInteractiveProcessFromServerModel(widget);
            }
            if (ImageCarouselWidgetHelper.isImageCarouselWidgetServerData(widget)) {
                return convertImageCarouselFromServerModel(widget);
            }
            if (InteractiveTabsHelper.isInteractiveTabsServerData(widget)) {
                return convertInteractiveTabsFromServerModel(widget);
            }
            if (FlipCardWidgetHelper.isFlipCardServerData(widget)) {
                return convertFlipCardWidgetFromServerModel(widget);
            }
            if (TextOnImageWidgetHelper.isTextOnImageServerData(widget)) {
                return convertTextOnImageFromServerModel(widget);
            }
            if (ListWidgetHelper.isListServerData(widget)) {
                return convertListFromServerModel(widget);
            }
            if (LabeledGraphicHelper.isLabeledGraphicServerData(widget)) {
                return convertLabeledGraphicFromServerModel(widget);
            }
            if (DividerWidgetHelper.isDividerServerData(widget)) {
                return convertDividerFromServerModel(widget);
            }
            if (SortationQuestionWidgetServerModelHelper.isSortationQuestionServerModel(widget)) {
                return SortationQuestionWidgetConverter.convertDomainModel(widget);
            }
            return WidgetHelper.buildWidget(widget.id, widget.trackingIdentifier, widget.data, widget.properties, widget.type);
        }
        catch {
            throw Error(`Failed converting widget with id: ${widget.id}`);
        }
    },
    convertServerModel: (widget) => {
        if (SingleResponseQuestionHelper.isSingleResponseQuestionWidget(widget)) {
            return SingleResponseQuestionWidgetConverter.convertToServerModel(widget);
        }
        if (MultipleResponseQuestionHelper.isMultipleResponseWidget(widget)) {
            return MultipleResponseQuestionWidgetConverter.convertToServerModel(widget);
        }
        if (FillInQuestionHelper.isFillInQuestionWidget(widget)) {
            return FillInQuestionWidgetConverter.convertToServerModel(widget);
        }
        if (HtmlWidgetHelper.isHtmlWidget(widget)) {
            return HtmlWidgetConverter.convertToServerModel(widget);
        }
        if (HiddenAreaWidgetHelper.isHiddenAreaWidget(widget)) {
            return HiddenAreaConverter.convertToServerModel(widget);
        }
        if (InteractiveProcessHelper.isInteractiveProcessWidget(widget)) {
            return convertInteractiveProcessWidgetToServerModel(widget);
        }
        if (ImageCarouselWidgetHelper.isImageCarouselWidget(widget)) {
            return convertImageCarouselWidgetToServerModel(widget);
        }
        if (InteractiveTabsHelper.isInteractiveTabsWidget(widget)) {
            return convertInteractiveTabsWidgetToServerModel(widget);
        }
        if (FlipCardWidgetHelper.isFlipCardWidget(widget)) {
            return convertFlipCardWidgetToServerModel(widget);
        }
        if (TextOnImageWidgetHelper.isTextOnImageWidget(widget)) {
            return convertTextOnImageWidgetToServerModel(widget);
        }
        if (ListWidgetHelper.isListWidget(widget)) {
            return convertListWidgetToServerModel(widget);
        }
        if (LabeledGraphicHelper.isLabeledGraphic(widget)) {
            return convertLabeledGraphicToServerModel(widget);
        }
        if (DividerWidgetHelper.isDividerWidget(widget)) {
            return convertDividerWidgetToServerModel(widget);
        }
        return { id: widget._id, trackingIdentifier: widget.trackingIdentifier, ...widget.value };
    },
};
